import { z } from "zod";

export const sealdDebugSearchSchema = z.object({
  entity_id: z
    .string()
    .trim()
    .min(1, "Enter an ID to search")
    .refine(
      (value) => Number.isInteger(Number(value)) && Number(value) > 0,
      "ID must be a whole number",
    ),
});

export type SealdDebugSearchFormValues = z.infer<typeof sealdDebugSearchSchema>;
